import { useState } from 'react'
import { ScanCard, Scan } from './ScanCard'
import { ScanDetailModal } from './ScanDetailModal'
import { FileSearch } from 'lucide-react'

interface ScanGalleryProps {
  scans: Scan[]
  isLoading: boolean
  studentId?: number // For parent view
  isParentView?: boolean
}

export function ScanGallery({
  scans,
  isLoading,
  studentId,
  isParentView = false,
}: ScanGalleryProps) {
  const [selectedScanId, setSelectedScanId] = useState<number | null>(null)

  if (isLoading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="animate-pulse bg-surface-card/50 rounded-lg p-4">
            <div className="flex gap-3">
              <div className="w-12 h-12 bg-gray-700 rounded-lg" />
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-gray-700 rounded w-2/3" />
                <div className="h-3 bg-gray-700 rounded w-1/3" />
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (scans.length === 0) {
    return (
      <div className="text-center py-12">
        <FileSearch className="w-16 h-16 text-gray-600 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-400">No scans found</h3>
        <p className="text-sm text-gray-500 mt-1">
          Try adjusting your filters or scan some documents
        </p>
      </div>
    )
  }

  return (
    <>
      <div className="space-y-3">
        {scans.map((scan) => (
          <ScanCard
            key={scan.id}
            scan={scan}
            onClick={() => setSelectedScanId(scan.id)}
            studentId={studentId}
            isParentView={isParentView}
          />
        ))}
      </div>

      {/* Detail Modal */}
      <ScanDetailModal
        scanId={selectedScanId || 0}
        isOpen={selectedScanId !== null}
        onClose={() => setSelectedScanId(null)}
        studentId={studentId}
        isParentView={isParentView}
      />
    </>
  )
}
